// extracted by mini-css-extract-plugin
module.exports = {"timer":"_iU","wrapper":"_iV","title":"_iW","counter":"_iX","separator":"_iY"};